
/**
 * Per,
 * https://docs.coveo.com/en/105/cloud-v2-developers/api-key-authentication
 * an API token meant to be stored client-side and only has permission
 * to execute queries.
 *
 */
const getAPIToken = () => {
  return process.env.ANALYTICS_API_KEY;
};

const getAnalyticsEndpoint = () => {
  return process.env.ANALYTICS_ENDPOINT;
};



/* global fetch */
const coveoUaSearch = async (searchUid = 0,text = '', vistorid =0, actionCause='') => {

  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const actionCauseParam = url.searchParams.get('actionCause');
    if (actionCauseParam && actionCauseParam.trim() && actionCause) {
      actionCause = actionCauseParam.trim();

      // Consume once: remove actionCause from the URL without reloading the page.
      url.searchParams.delete('actionCause');
      const nextUrl = `${url.pathname}${url.search}${url.hash}`;
      window.history.replaceState(window.history.state, '', nextUrl);
    }
  }

  return fetch(`${getAnalyticsEndpoint()}/v15/analytics/search`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${getAPIToken()}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      "anonymous": true,
      "clientId": vistorid,
      "language": "en-US",
      "originLevel1": "customer-education",
      "originLevel2": "customer-education",
      "actionCause": actionCause,
      "queryText": text,
       "responseTime": 145,
      "searchQueryUid": searchUid,
      "userAgent": global.navigator.userAgent
    })
  });
};

export default coveoUaSearch;
